module.exports = __webpack_public_path__ + "static/media/38806364_wrong-answer-notification-03.c5c592fe.mp3";